import React, { useState } from 'react'
import RecipeCreateForm from '../../components/RecipeCreate/RecipeCreateForm'
import { useDispatch, useSelector } from 'react-redux'
import { uploadImageCloudinaryApi } from '../../api/file.api';
import { createRecipeApi } from "../../api/recipe.api";
import swal from 'sweetalert';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-hot-toast';
import { addListIngredients } from '../../api/recipeIngredient.api';
import { useNavigate } from 'react-router-dom';
import { offLoading } from '../../redux/loading.slice';
import { showSignInPopup } from '../../redux/auth.slice';

const CreateRecipeContainer = () => {
    const currentUser = useSelector(state => state.auth.signIn.currentUser);
    const navigate = useNavigate();
    const [imageURL, setImageURL] = useState('');
    const [ingredients, setIngredients] = useState([]);
    const dispatch = useDispatch();

    const upLoadFilesForCreate = (formData, token) => {
        uploadImageCloudinaryApi(formData, token, dispatch)
            .then((response) => {
                setImageURL(response.data);
            })
            .then(() => {
                dispatch(offLoading());
            })
            .catch((err) => {
                dispatch(offLoading());
                toast.error("Failed upload image!")
            })
    }

    const handleChangeImage = (event) => {
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        const file = formData.get("file");
        // file.url = URL.createObjectURL(file);
        // setImageURL({ name: file.name, url: file.url })
        upLoadFilesForCreate(file, currentUser.token);
    }

    const formikRecipe = useFormik({
        initialValues: {
            name: '',
            description: '',
            processingSteps: '',
            note: '',
            point: ''

        },
        validationSchema: yup.object().shape({
            name: yup.string().required('Required'),
            description: yup.string().required('Required'),
            processingSteps: yup.string().required('Required'),
            note: yup.string().required('Required'),
            point: yup.number().min(0, 'point must be greater than or equal 0').required('required')
        }),
        onSubmit: values => {
            const recipe = { ...values };
            if (ingredients.length > 0 && imageURL !== '') {
                createRecipeApi({
                    name: String(recipe.name),
                    description: String(recipe.description),
                    imageUrl: String(imageURL),
                    processingSteps: String(recipe.processingSteps),
                    note: recipe.note,
                    point: Number(recipe.point),
                    creator: Number(currentUser.id)
                }, currentUser.token)
                    .then(response => {
                        return response.data;
                    })
                    .then((data) => {
                        const type = typeof (data);
                        if (type === 'string') {
                            toast.error(data);
                        }
                        if (type === 'number') {
                            // toast.success("Create Recipe successfully");
                            const recipeId = data;
                            const list = [];
                            ingredients.forEach(ingredient => {
                                ingredient.recipeId = recipeId;
                                list.push(ingredient);
                            });
                            setIngredients(list);
                        }
                    })
                    .then(() => {
                        addListIngredients(ingredients, currentUser.token)
                            .then((res) => {
                                // console.log(res.data)
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                            ;
                    })
                    .then(() => {
                        swal({
                            icon: "success",
                            title: "Success",
                            text: "Your recipe has been successfully created!",
                        }).then(() => {
                            navigate('/')
                        })
                    })
                    .catch(err => {
                        console.log(err);
                        toast.error("Create Recipe failed!");
                    })
            } else {
                ingredients.length === 0 && toast.error("You haven't added ingredients to the recipe yet!");
                imageURL === '' && toast.error("Please upload image before submit!")
            }
        }
    })

    const formikIngredient = useFormik({
        initialValues: {
            name: '',
            amount: '',
            unit: ''
        },
        validationSchema: yup.object().shape({
            name: yup.string().required('Required'),
            amount: yup.number().required('Required'),
            unit: yup.string().required('Required')
        }),
        onSubmit: values => {
            const ingredient = { ...values };
            const list = [...ingredients, ingredient];
            setIngredients(list);
            values.name = '';
            values.amount = '';
            values.unit = '';
        }
    })


    const removeIngredient = (ingredientName) => {
        const list = ingredients.filter(item => item.name !== ingredientName);
        setIngredients(list);
    }

    if (!currentUser) {
        setTimeout(() => {
            dispatch(showSignInPopup());
        }, 500)
    }

    return (
        <RecipeCreateForm
            formikIngredient={formikIngredient}
            formikRecipe={formikRecipe}
            handleChangeImage={handleChangeImage}
            imageURL={imageURL}
            ingredients={ingredients}
            removeIngredient={removeIngredient}
            setImageURL={setImageURL}
        />
    )
}

export default CreateRecipeContainer